var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Chi tiết đơn xin nghỉ",
            visible: _vm.dialogVisible,
            width: "650px",
            "before-close": _vm.closeDialogByButton,
            "close-on-click-modal": false,
            top: "5vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "section",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isLoading,
                  expression: "isLoading",
                },
              ],
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c("div", { staticClass: "shift-card" }, [
                      _c("div", { staticClass: "shift-header" }, [
                        _c(
                          "div",
                          { staticClass: "student-profile" },
                          [
                            _c("el-avatar", {
                              staticClass: "student-avatar",
                              attrs: {
                                size: 40,
                                src: _vm.absentLetterData.avatar,
                                icon: "el-icon-user-solid",
                              },
                            }),
                            _c("div", [
                              _c("strong", { staticClass: "student-name" }, [
                                _vm._v(
                                  _vm._s(_vm.absentLetterData.nameStudent)
                                ),
                              ]),
                              _c("div", { staticClass: "class-name" }, [
                                _vm._v(
                                  "Lớp: " +
                                    _vm._s(_vm.absentLetterData.className)
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "status-cell" }, [
                          _c(
                            "span",
                            {
                              class: [
                                "status-badge",
                                `status-badge--${(
                                  _vm.absentLetterData.status || ""
                                ).toLowerCase()}`,
                              ],
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.getStatus()) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "meta-info-list" }, [
                        _c("div", { staticClass: "meta-row-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v("Người làm đơn"),
                          ]),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v("\n    :"),
                            _c("i", { staticClass: "el-icon-user" }),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.absentLetterData.createdBy || "Phụ huynh"
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "meta-row-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v("Ngày tạo đơn"),
                          ]),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v("\n    :"),
                            _c("i", { staticClass: "el-icon-date" }),
                            _vm._v(
                              "\n    " +
                                _vm._s(
                                  _vm._f("formatDateTime")(
                                    _vm.absentLetterData.createdDate
                                  )
                                ) +
                                "\n  "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "meta-row-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v("Tổng thời gian nghỉ"),
                          ]),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v("\n    : Từ "),
                            _c("strong", { staticClass: "text-highlight" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.absentLetterData.fromDate
                                  )
                                )
                              ),
                            ]),
                            _vm._v("\n    đến "),
                            _c("strong", { staticClass: "text-highlight" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(
                                    _vm.absentLetterData.toDate
                                  )
                                )
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "meta-row-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v("Số ngày nghỉ"),
                          ]),
                          _c("span", { staticClass: "meta-value" }, [
                            _vm._v("\n    : "),
                            _c("span", { staticClass: "days-count-badge" }, [
                              _vm._v(
                                _vm._s(_vm.absentLetterData.totalDay || 0) +
                                  " ngày"
                              ),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "meta-row-item" }, [
                          _c("span", { staticClass: "meta-label" }, [
                            _vm._v("Lý do nghỉ"),
                          ]),
                          _c(
                            "span",
                            { staticClass: "meta-value text-reason" },
                            [
                              _vm._v("\n    : "),
                              _c(
                                "el-tag",
                                {
                                  staticStyle: { "margin-right": "8px" },
                                  attrs: {
                                    type: "danger",
                                    size: "mini",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n      " +
                                      _vm._s(
                                        _vm.getReasonType(
                                          _vm.absentLetterData.reasonType
                                        )
                                      ) +
                                      "\n    "
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n    " +
                                  _vm._s(
                                    _vm.absentLetterData.reasonOther || ""
                                  ) +
                                  "\n  "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "content-section" }, [
                        _c("div", { staticClass: "section-title-small" }, [
                          _vm._v("Nội dung:"),
                        ]),
                        _c("div", { staticClass: "note-blockquote" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.absentLetterData.content ||
                                  "Không có nội dung chi tiết"
                              ) +
                              "\n              "
                          ),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "shift-card" }, [
                      _c("div", { staticClass: "card-sub-title" }, [
                        _c("i", { staticClass: "el-icon-date" }),
                        _vm._v(
                          " Danh sách chi tiết các ngày nghỉ\n            "
                        ),
                      ]),
                      _c("div", { staticClass: "permission-summary" }, [
                        _c("div", { staticClass: "summary-box approved" }, [
                          _c("span", { staticClass: "num" }, [
                            _vm._v(
                              _vm._s(
                                _vm.absentLetterData.approvedDates
                                  ? _vm.absentLetterData.approvedDates.length
                                  : 0
                              )
                            ),
                          ]),
                          _c("span", { staticClass: "lbl" }, [
                            _vm._v("Ngày có phép"),
                          ]),
                        ]),
                        _c("div", { staticClass: "summary-box unapproved" }, [
                          _c("span", { staticClass: "num" }, [
                            _vm._v(
                              _vm._s(
                                _vm.absentLetterData.unpermittedDates
                                  ? _vm.absentLetterData.unpermittedDates.length
                                  : 0
                              )
                            ),
                          ]),
                          _c("span", { staticClass: "lbl" }, [
                            _vm._v("Ngày không phép"),
                          ]),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "date-grid-container" },
                        [
                          _vm._l(_vm.computedDateList, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "date-grid-item",
                                class: { "is-permitted": item.hasPermission },
                              },
                              [
                                _c("div", { staticClass: "grid-item-header" }, [
                                  _c("i", {
                                    class: item.hasPermission
                                      ? "el-icon-success"
                                      : "el-icon-warning",
                                  }),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.hasPermission
                                          ? "Có phép"
                                          : "Không phép"
                                      )
                                    ),
                                  ]),
                                ]),
                                _c("div", { staticClass: "grid-item-body" }, [
                                  _c("span", { staticClass: "month-year" }, [
                                    _vm._v(
                                      _vm._s(_vm._f("formatDate")(item.date))
                                    ),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                          _vm.computedDateList.length === 0
                            ? _c("div", { staticClass: "empty-grid" }, [
                                _vm._v(
                                  "\n                Không có dữ liệu ngày nghỉ cụ thể.\n              "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]),
                    _vm.absentLetterData.attachments &&
                    _vm.absentLetterData.attachments.length > 0
                      ? _c("div", { staticClass: "shift-card" }, [
                          _c("div", { staticClass: "card-sub-title" }, [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" Ảnh đính kèm"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "image-preview-container" },
                            _vm._l(_vm.attachments, function (img, index) {
                              return _c(
                                "el-image",
                                {
                                  key: index,
                                  staticClass: "preview-img",
                                  attrs: {
                                    src: img,
                                    "preview-src-list": _vm.attachments,
                                    fit: "cover",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm.absentLetterData.status !== "PENDING"
                      ? _c("div", { staticClass: "shift-card" }, [
                          _c("div", { staticClass: "card-sub-title" }, [
                            _c("i", { staticClass: "el-icon-user" }),
                            _vm._v(" Thông tin phê duyệt"),
                          ]),
                          _c("div", { staticClass: "processor-box" }, [
                            _c("div", { staticClass: "processor-info" }, [
                              _c("div", { staticClass: "avatar-placeholder" }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      (_vm.absentLetterData.nameConfirm || "QT")
                                        .substring(0, 2)
                                        .toUpperCase()
                                    ) +
                                    "\n                "
                                ),
                              ]),
                              _c("div", [
                                _c("h4", { staticClass: "processor-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.absentLetterData.nameConfirm ||
                                        "Hệ thống / Giáo viên"
                                    )
                                  ),
                                ]),
                                _c("span", { staticClass: "processed-time" }, [
                                  _c("i", { staticClass: "el-icon-time" }),
                                  _vm._v(
                                    " Thời gian duyệt: " +
                                      _vm._s(
                                        _vm._f("formatDateTime")(
                                          _vm.absentLetterData.confirmDate
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.absentLetterData.status === "PENDING"
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.isLoadingSave,
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleApprove()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _vm._v(" Duyệt đơn\n      "),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: { click: _vm.closeDialogByButton },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }